'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _IconButton = require('@material-ui/core/IconButton');
var _IconButton2 = _interopRequireDefault(_IconButton);
var _Menu = require('@material-ui/core/Menu');
var _Menu2 = _interopRequireDefault(_Menu);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  iconButton: {
    alignSelf: 'center'
  }
};
var DropdownMenu = function (_Component) {
  _inherits(DropdownMenu, _Component);
  function DropdownMenu(props) {
    _classCallCheck(this, DropdownMenu);
    var _this = _possibleConstructorReturn(this, (DropdownMenu.__proto__ || Object.getPrototypeOf(DropdownMenu)).call(this, props));
    _this.openMenu = function (event) {
      _this.setState({
        anchorElement: event.currentTarget
      });
    };
    _this.closeMenu = function () {
      _this.setState({
        anchorElement: null
      });
    };
    _this.state = {
      anchorElement: null
    };
    return _this;
  }
  _createClass(DropdownMenu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        menuId = _props.menuId,
        icon = _props.icon,
        menuItems = _props.menuItems,
        classes = _props.classes,
        _props$closeOnSelect = _props.closeOnSelect,
        closeOnSelect = _props$closeOnSelect === undefined ? true : _props$closeOnSelect;
      var anchorElement = this.state.anchorElement;
      var open = !!anchorElement;
      var id = menuId + '-menu';
      return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_IconButton2.default, {
        'aria-owns': open ? id : null,
        'aria-haspopup': 'true',
        onClick: this.openMenu,
        color: 'inherit',
        className: classes.iconButton
      }, icon), _react2.default.createElement(_Menu2.default, {
        id: id,
        anchorEl: anchorElement,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'right'
        },
        open: open,
        onClose: this.closeMenu,
        onClick: closeOnSelect && this.closeMenu
      }, menuItems));
    }
  }]);
  return DropdownMenu;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)(DropdownMenu);